import backgroundSemiFinal from "@images/backgroundSemiFinal.png"
import { HUPortableText } from "@modules/common/cms/components/huPortableText"
import { word } from "@modules/core/utils/i18n"
import { CrossFitEvent } from "@modules/crossfitEvent/entities/crossfitEventEntity"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { HURow } from "@modules/ui/components/layout"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { YouTubeVideo } from "@modules/utils/components/youTubeVideo"
import styled, { useTheme } from "styled-components"

type CrossfitEventCardProps = {
  crossfitEvent: CrossFitEvent
}

export const CrossfitEventDetailsInfo : React.FC<CrossfitEventCardProps> = ({ crossfitEvent }) => {
  const theme = useTheme()

  const openWebsite = (link: string) => {
    window.open(link, "_blank")
  }

  return (
    <>
      {crossfitEvent ? (
        <div className="flex flex-column flex-grow-1">
          <HeaderContainer>
            <LogoSemiFinalCompetition
              $logoSemiFinal={crossfitEvent.logo?.uri || ""}
            />
            <div className="relative flex justify-content-center">
              <CrossFitTag>
                <HUText fontStyle="LL" color={theme.neutralColor900}>
                  {word(`semiFinals.crossfitSemiFinal.tag`)}
                </HUText>
              </CrossFitTag>
              <BackgroundContainer
                $bgImage={backgroundSemiFinal}
                className="p-5 mb-5 flex-row justify-content-center align-items-center overflow-hidden gap-2 border-noround-top "
              >
                <TitleContainer>
                  <HURow className="gap-2">
                    <HUText fontStyle="TL" color={theme.neutralColor900}>
                      {crossfitEvent.subtitle}
                    </HUText>
                  </HURow>
                </TitleContainer>
              </BackgroundContainer>
            </div>
          </HeaderContainer>
          <InfoContainer>
            <TitleCompetition fontStyle="TM" color={theme.neutralColor900}>
              {crossfitEvent.title}
            </TitleCompetition>
            <Line>
              <HUText fontStyle="LL" color={theme.neutralColor700} className="mr-2">
                {`${word("sessionForm.startTime.title")} : `}
              </HUText>
              <HUText fontStyle="BL" color={theme.neutralColor900}>
                {crossfitEvent.date.start}
              </HUText>
            </Line>
            <Line>
              <HUText fontStyle="LL" color={theme.neutralColor700} className="mr-2">
                {`${word("semiFinals.crossfitSemiFinal.ended")} : `}
              </HUText>
              <HUText fontStyle="BL" color={theme.neutralColor900}>
                {crossfitEvent.date.end}
              </HUText>
            </Line>
            <Line>
              <HUText fontStyle="LL" color={theme.neutralColor700} className="mr-2" >
                {`${word("semiFinals.crossfitSemiFinal.place")} : `}
              </HUText>
              <HUText fontStyle="BL" color={theme.neutralColor900}>
                {crossfitEvent.place}
              </HUText>
            </Line>
            <Line className="justify-content-between mt-3 px-6 ">
              <HUButton
                type="Default"
                size="M"
                colorType="Quaternary"
                text={word("semiFinals.crossfitSemiFinal.getTickets")}
                onClick={() => openWebsite(crossfitEvent.cta?.tickets ?? "")}
              />
              <HUButton
                type="Default"
                size="M"
                colorType="Quaternary"
                text={word("semiFinals.crossfitSemiFinal.website")}
                onClick={() => openWebsite(crossfitEvent.cta?.website ?? "")}
              />
            </Line>
          </InfoContainer>
          <ContentContainer>
            <HUPortableText value={crossfitEvent.description || []} />
            {crossfitEvent.watchLive && (
              <div className="mt-2">
                <YouTubeVideo link={crossfitEvent.watchLive[0].url} width={540} />
              </div>
            )}
          </ContentContainer>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  )
}

const HeaderContainer = styled.div`
  margin: -85px -20px;
  position: relative;
`

const BackgroundContainer = styled.div<{ $bgImage?: string }>`
  position: relative;
  border-radius: 33px;
  border-width: 0px;
  height: 370px;
  background-image: ${({ $bgImage }) => `url(${$bgImage})`};
  background-size: cover;
  background-position: center;
  width: 100%;
`

const TitleContainer = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 30px;
`
const CrossFitTag = styled.div`
  position: absolute;
  bottom: 95px;
  left: 20px;
  border-radius: 44px;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(7px);
  padding: 9px 12px 8px 12px;
  z-index: 2;
`

const ContentContainer = styled.div`
  margin-top: 20px;
  text-align: justify;
`
const InfoContainer = styled.div`
  margin-top: 70px;
`
const Line = styled.div`
  display: flex;
  align-items: baseline;
`
const TitleCompetition = styled(HUText)`
  margin-bottom: 20px;
`

const LogoSemiFinalCompetition = styled.div<{
  $logoSemiFinal: string
  $heightLogo?: number
  $widthLogo?: number
  $rightSize?: number
  $topSize?: number
}>`
  position: absolute;
  top: ${({ $topSize }) => ($topSize ? `${$topSize}%` : "10%")};
  right: ${({ $rightSize }) => ($rightSize ? `${$rightSize}%` : "15%")};
  background-image: ${({ $logoSemiFinal }) => `url(${$logoSemiFinal})`};
  background-size: contain;
  background-position: center;
  height: ${({ $heightLogo }) => ($heightLogo ? `${$heightLogo}%` : "67%")};
  width: ${({ $widthLogo }) => ($widthLogo ? `${$widthLogo}%` : "62%")};
  background-repeat: no-repeat;
  z-index: 3;
`
